export const PageDataState = {
    Searchs: {
        certification_eb_04_id: {
            type: 'text',
            id: 'certification_eb_04_id',
            label: '',
            value: '',
            placeholder: ''
        },
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ-สกุล',
            value: '',
            placeholder: 'ชื่อ-สกุล'
        },         
        cardid: {
            type: 'text',
            id: 'cardid',
            label: 'บัตรประชาชน',
            value: '',
            placeholder: 'หมายเลขบัตรประชาชน',
        }, 
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        certification_eb_04_id: {
            type: 'select',
            id: 'certification_eb_04_id',
            label: 'รุ่น/ผู้ประกอบการ/ผู้รายงาน',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },        
        fullname: {
            type: 'text',
            id: 'fullname',
            label: 'ชื่อ-สกุล',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        cardid: {
            type: 'text',
            id: 'cardid',
            label: 'หมายเลขบัตรประชาชน',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 13,
                maxLength: 13
            },
            error: { status: null, msg: '' }
        },  
        position_before_training: {
            type: 'text',
            id: 'position_before_training',
            label: 'ตำแหน่ง (ก่อนอบรม)',
            value: '',
            placeholder: 'ตำแหน่ง',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        income_before_training: {
            type: 'text',
            id: 'income_before_training',
            label: 'เงินเดือน (ก่อนอบรม)',
            value: '',
            validator: {
                type: 'number',
                required: false,
                minLength: 1000,
                maxLength: 100000
            },
            error: { status: null, msg: '' }
        },         
        position_after_training: {
            type: 'text',
            id: 'position_after_training',
            label: 'ตำแหน่ง (หลังอบรม)',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },         
        income_after_training: {
            type: 'text',
            id: 'income_after_training',
            label: 'เงินเดือน (หลังอบรม)',
            value: '',
            validator: {
                type: 'number',
                required: false,
                minLength: 1000,
                maxLength: 100000
            },
            error: { status: null, msg: '' }
        },   
        pre_test: {
            type: 'text',
            id: 'pre_test',
            label: 'PRE TEST',
            value: '',
            validator: {
                type: 'number',
                required: true,
                minLength: 0,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        }, 
        post_test: {
            type: 'text',
            id: 'post_test',
            label: 'POST TEST',
            value: '',
            validator: {
                type: 'number',
                required: true,
                minLength: 0,
                maxLength: 2
            },
            error: { status: null, msg: '' }
        }, 
        job_accept_flag: {
            type: 'checkbox',
            group: 'input_job_accept_flag',
            id: 'job_accept_flag',
            label: '',
            value: '',
            placeholder: 'รับเข้าทำงาน',
            validator: {
                type: 'text',
                required: false,
                minLength: 1,
                maxLength: 1
            },            
        },                                 
        seq: {
            type: 'text',
            id: 'seq',
            label: 'ลำดับ',
            value: '',
            validator: {
                type: 'number',
                required: true,
                min: 1,
                max: 250
            },
            error: { status: null, msg: '' }
        }  
    },
    InputGroup: {
        Checkbox: {
            input_job_accept_flag: {
                display: 'inline',
                label: '',
                inputs: [
                        {id: 'job_accept_flag', value: '1'},
                ],
                validator: {
                    type: 'checkbox',
                    required: false,
                },
                error: { status: null, msg: '' },
            }            
        }        
    },
}        